var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircularIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 10.25C7.34721 10.25 9.25 8.3472 9.25 5.99999C9.25 4.58722 8.56067 3.33545 7.5 2.56269M5.5 11.2L4.5 10.2L5.5 9.19999M5 1.74999C2.65279 1.74999 0.75 3.65278 0.75 5.99999C0.75 7.41276 1.43933 8.66452 2.5 9.43729M4.5 2.79999L5.5 1.79999L4.5 0.799988",
    stroke: "#6172F3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircularIcon);
export default __webpack_public_path__ + "static/media/circular-icon.333dff562e4b588cd0febec4c4bb7d4f.svg";
export { ForwardRef as ReactComponent };